import { joinShare } from '@jotta/grpc-connect-openapi/esm/openapi/sharing/v2/sharing.v2-SharingService_connectquery'
import { useMutation } from '@connectrpc/connect-query'
import { authTransport } from '../transport'

export function useJoinShare() {
  return useMutation(joinShare, { transport: authTransport })
}
